// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".closeBtn[data-v-661ab544]{cursor:pointer}.actionBackgroundGray[data-v-661ab544]{background-color:hsla(0,0%,66.3%,.1)}.action-wrapper[data-v-661ab544]{border-top:.1em dotted grey}.action-wrapper[data-v-661ab544] .v-btn{margin-bottom:8px;margin-right:0!important;margin-left:0!important}", ""]);
// Exports
module.exports = exports;
